import { PageContainer } from '@shared';

import { OrganizationAddressesSection } from '@/features/settings/OrganizationAddressesSection';
import { PersonalSettingsSection } from '@/features/settings/PersonalSettingsSection';
import { OrganizationSettingsSection } from '@/features/settings/OrganizationSettingsSection';
import { useTranslations } from '@/i18n/client';
import type { OrganizationApi } from '@/services/api/organization-api';
import type { UserApi } from '@/services/api/user-api';

export interface SettingsPageProps {
  /** Test-only injection point for a mock OrganizationApi. */
  organization?: OrganizationApi;
  /** Test-only injection point for a mock UserApi. */
  user?: UserApi;
}

export function SettingsPage({ organization, user }: SettingsPageProps) {
  const t = useTranslations('settings');

  return (
    <PageContainer className="md-settings-page max-sm:w-full max-sm:[&_.zs-card]:p-4 max-sm:[&_.zs-card__actions]:flex-col max-sm:[&_.zs-card__actions]:items-stretch max-sm:[&_.zs-card__actions_.zs-button]:w-full">
      <section
        className="rounded-[var(--zs-radius-m)] border border-[var(--md-border)] border-t-4 border-t-[var(--md-primary)] bg-[var(--md-white)] px-8 py-8 shadow-[var(--md-shadow-soft)] lg:px-10 max-sm:p-4 max-sm:[&>div>section]:py-5"
        aria-labelledby="settings-page-title"
      >
        <div className="flex flex-wrap items-start justify-between gap-4 pb-6 max-sm:flex-col max-sm:gap-3 max-sm:pb-4">
          <h1 id="settings-page-title" className="md-page__title">
            {t('page.title')}
          </h1>
        </div>
        <div className="border-t border-[var(--md-border)]">
          <OrganizationSettingsSection embedded {...(organization ? { organization } : {})} />
        </div>
        <div className="border-t border-[var(--md-border)]">
          <PersonalSettingsSection embedded {...(user ? { user } : {})} />
        </div>
        <div className="border-t border-[var(--md-border)]">
          <OrganizationAddressesSection embedded {...(organization ? { organization } : {})} />
        </div>
      </section>
    </PageContainer>
  );
}
